//import RichTextFormEditor from "components/elements/editor/RichTextFormEditor";
import { Table } from "@mantine/core";
import { CustomTextarea } from "pages/admin/components/CustomTextArea";
import { FormTableLayout } from "pages/admin/components/FormatTableLayout";
import React from "react";
import { DebtorManagementChildFormProps } from "types/interface.types";

const CustomerDetailsCard3: React.FC<DebtorManagementChildFormProps> = ({
  readonly,
  formApi,
}) => {
  const { values, setFieldValue } = formApi;

  return (
    <div className="card-container ">
      {!readonly && (
        <FormTableLayout>
          <Table.Tbody>
            <Table.Tr>
              <Table.Td>
                <CustomTextarea
                  readonlyMode={readonly}
                  label="Special Instructions"
                  value={values.specialNotes}
                  onChange={(v) => setFieldValue("specialNotes", v)}
                />
              </Table.Td>
            </Table.Tr>
          </Table.Tbody>
        </FormTableLayout>
      )}
    </div>
  );
};
export default React.memo(CustomerDetailsCard3);
